import axios from 'axios';

export default axios.create({
    baseURL: `https://website-backend-954892797856.us-central1.run.app`
});